// src/components/IntegrationsEmpty.tsx
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Card, CardBody } from "reactstrap";

const IntegrationsEmpty: React.FC<WithTranslation> = ({ t }) => (
  <Card
    className="mx-auto shadow-sm rounded my-5"
    style={{ maxWidth: 400 }}
  >
    <CardBody className="text-center p-5">
      <i
        className="ri-apps-line text-secondary mb-4"
        style={{ fontSize: 56 }}
      />
      <h4 className="mb-3 text-secondary">
        {t("integrations.empty.title", "No integrations available")}
      </h4>
      <p className="text-muted mb-0">
        {t(
          "integrations.empty.subtitle",
          "We don’t have any integrations published at the moment."
        )}
      </p>
    </CardBody>
  </Card>
);

export default withTranslation()(IntegrationsEmpty);
